class ProductOptions extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.available_variants = []),
      (this.container = this.querySelector(".product-options--container")),
      (this.first_variant = JSON.parse(
        this.querySelector("[id*=variant-first--json]").innerHTML
      )),
      (this.inputs = this.container.querySelectorAll(
        '[data-item="disclosure"], [data-item="radio"]'
      )),
      (this.is_product_page = null !== this.closest(".product-page--root")),
      (this.option_values = []),
      (this.variants = JSON.parse(
        this.querySelector("[id*=variant--json]").innerHTML
      )),
      this.getVariantOptions(),
      this.disableEmptyOptions(),
      this.optionChangeListener(),
      this.is_product_page &&
        this.inputs.forEach((t) => {
          t.checked && t.dispatchEvent(new Event("change"));
        });
  }
  disconnectedCallback() {
    this.inputs.off("change.ProductOptions");
  }
  getVariantOptions() {
    if (
      (this.variants.forEach(
        (t) => t.available && this.available_variants.push(t.options)
      ),
      0 < this.available_variants.length)
    )
      for (let i = 0; i < this.available_variants[0].length; i++)
        this.option_values[i] = [
          ...new Set(this.available_variants.map((t) => t[i])),
        ];
  }
  disableEmptyOptions() {
    const e = this.option_values.flat();
    this.container
      .querySelectorAll(".radios--input, .disclosure--option")
      .forEach((t) => {
        var i = this.getOptionValue(t);
        e.includes(i) || t.setAttribute("data-empty", !0);
      });
  }
  optionChangeListener() {
    this.inputs.on("change.ProductOptions", ({ target: t }) => {
      const a = [];
      const radiosRoot = t.closest(".radios--root");
      const radiosHeader = radiosRoot
        ? radiosRoot.querySelector(".radios--header")
        : null;
      if (radiosHeader) {
        let selectedValue = radiosHeader.querySelector(".selectedValue");
        if (!selectedValue) {
          selectedValue = document.createElement("span");
          selectedValue.classList.add("selectedValue");
          radiosHeader.appendChild(selectedValue);
        }
        selectedValue.textContent = t.value;
      }
      this.container
        .querySelectorAll(
          '[data-item="disclosure"], [data-item="radio"]:checked'
        )
        .forEach((t) => {
          var i = t.closest(".product-options--option").dataset.index;
          a.push({ index: i, value: t.value });
        }),
        this.hideOptions(
          a.map((t) => t.value),
          t.closest(".product-options--option").index()
        );
      let s = !1;
      this.variants.every((i) => {
        let e = !0;
        return (
          a.forEach((t) => {
            e = e && i.options[t.index] === t.value;
          }),
          !e || ((s = i), !1)
        );
      }),
        this.updateVariant(s);
    });
  }
  updateVariant(t) {
    this.is_product_page && this.updateHistoryState(t.id),
      window.trigger(`theme:product:${this.dataset.id}:variantChanged`, {
        variant: t,
      });

    this.is_product_page ? this.updateStockInfo(t) : this.updateListingPopup(t);

    const quickAddForm = this.closest(".product--quick-add--form");
    const skuEl = quickAddForm ? quickAddForm.querySelector(".product--sku--value") : null;
    if (skuEl) {
      const sku = t.sku ? t.sku : "";
      skuEl.textContent = sku;
    }
  }
  updateStockInfo(t) {
    const productWrapper = document.querySelector(".product-page--root");
    if (productWrapper) {
      productWrapper.setAttribute("data-variant-exists", !!t);
      productWrapper.setAttribute("data-variant-available", !!t && t.available);
    }
  }
  updateListingPopup(t) {
    const quickAddForm = this.closest(".product--quick-add--form");
    const notifyMyButton = quickAddForm ? quickAddForm.querySelector('.BIS_trigger') : null;
    const buyButtons = quickAddForm ? quickAddForm.querySelector('.product-buy-buttons--root') : null;
    if (notifyMyButton && buyButtons) {
      if (t.available === false && t.id) {
        notifyMyButton.setAttribute("data-variant-id", t.id);
        notifyMyButton.style.display = "flex";
        buyButtons.style.display = "none";
      } else {
        notifyMyButton.style.display = "none";
        buyButtons.style.display = "block";
      }
    }
  }
  updateHistoryState(t) {
    let i = "" + location.origin + location.pathname;
    t && (i += "?variant=" + t), history.replaceState({ path: i }, "", i);
  }
  hideOptions(a, i) {
    if (a[0] !== this.option_values[0][0]) {
      a.unshift(this.option_values[0][0]);
    }
    const productRoot = this.is_product_page && document.querySelector(".product-page--root") ? document.querySelector(".product-page--root") : null;
    if (a.length !== this.option_values.length && productRoot) {
      productRoot.setAttribute("data-variant-selected", false);
    } else if (a.length === this.option_values.length && productRoot) {
      productRoot.setAttribute("data-variant-selected", true);
    }
    const s =
      0 === this.option_values.length
        ? []
        : this.option_values.map((values, e) => {
            if (e === 0) return values;
            if (e === 1) return values;
            return values.filter((value) => {
              const temp = [...a];
              temp[e] = value;
              return this.available_variants.some(
                (variant) => variant.join(",") === temp.join(",")
              );
            });
          });

    this.container
      .querySelectorAll(".product-options--option")
      .forEach((option, e) => {
        if (this.option_values.length === 3) {
          if (e === 1) {
            // Second option is always available
            option
              .querySelectorAll(".radios--input, .disclosure--option")
              .forEach((t) => {
                t.setAttribute("data-unavailable", false);
              });
          } else if (e === 2) {
            // Third option is related to the second option
            option
              .querySelectorAll(".radios--input, .disclosure--option")
              .forEach((t) => {
                var i = this.getOptionValue(t);
                t.setAttribute("data-unavailable", !(s[e] && s[e].includes(i)));
                // Remove 'disabled' if the second option is selected
                console.log('a', a);
                if (a[1]) {
                  t.removeAttribute("disabled");
                } else {
                  t.setAttribute("disabled", true);
                }
              });
          }
        } else if (e != i && s[e]) {
          // Logic for products with 2 options (default behavior)
          option
            .querySelectorAll(".radios--input, .disclosure--option")
            .forEach((t) => {
              var i = this.getOptionValue(t);
              t.setAttribute("data-unavailable", !(s[e] && s[e].includes(i)));
            });
        }
      });
  }
  getOptionValue(t) {
    return t.getAttribute("data-value")
      ? t.getAttribute("data-value")
      : t.value;
  }
}
const productOptionsEl = customElements.get("product-options-root");
productOptionsEl ||
  customElements.define("product-options-root", ProductOptions);
